export default "__VITE_ASSET__CUFnusJl__"